import React, {useCallback, useState} from 'react';
import I18n from 'app/i18n';

interface Props {
    questionItem: {
        date: string
        questions: Question[]
    };
    numberDay: number;
}

interface Question {
    content: string
    content_langs: {
        [date: string]: string
    }
    id: number
}

const GrandSlamLandingQuestionItem: React.FC<Props> = ({questionItem, numberDay}) => {
    const [openItem, setOpenItem] = useState<boolean>(false);

    const onClick = () => {
        setOpenItem(!openItem);
    };

    const handleOnClick = useCallback(() => onClick(), [onClick]);

    const formatDayAndMonth = (dateQuestion: string) => {
        const [day, month] = dateQuestion.split('-').reverse();

        return ` ${Number(day)} ${I18n.t(`global.month_${Number(month)}_2`)}`.toLowerCase();
    };

    const getQuestions = (questions: Question[]) => {
        if (!questions) {
            return [];
        }

        const localeQuestion = localStorage.getItem('language') === 'en' ? questions[0]?.content : questions[0]?.content_langs?.ru;

        return (localeQuestion ?? '').match(/[^?]+\?/gu) || [];
    };

    return <>
        <div className={`landing-promo-faq-item${openItem ? ' active' : ''}`} onClick={handleOnClick}>
            <span className="title-faq">
                {I18n.t('grand_slam.question_for_day', {number_day: numberDay})}
                {formatDayAndMonth(questionItem.date)}
            </span>
            <div className="description-faq description-questions">
                {getQuestions(questionItem.questions)
                    .map((item, index) => <div className="question" key={`question-item-${questionItem.date}-${index}`}>
                        <span>{item}</span>
                    </div>)}
            </div>
        </div>
    </>;
};

export default GrandSlamLandingQuestionItem;
